module.exports = __webpack_public_path__ + "img/4.df5831cd.jpg";